import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { extractError } from '@/helpers/extractApiError';
import CrossReferenceService from '@/services/CatalogServices/CrossReferenceService';

const model = {
    id: null,
    submitting: false,
    error: null,
    successOnDelete: '',
};

export const deleteCrossReference = createAsyncThunk(
    'crossReference/deleteCrossReference',
    async (crossReferenceId, { rejectWithValue }) => {
        try {
            const response = await CrossReferenceService.deleteCrossReference(crossReferenceId);
            return {
                crossReferenceId,
                data: response.data,
            };
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const deleteCrossReferenceSlice = createSlice({
    name: 'deleteCrossReference',
    initialState: model,
    reducers: {
        resetDeleteCrossReferenceStateOnError: (state) => {
            state.error = null;
        },
        resetDeleteCrossReferenceStateOnSuccess: (state) => {
            state.successOnDelete = '';
        },
    },
    extraReducers: (builder) => {
        // delete cross reference
        builder.addCase(deleteCrossReference.pending, (state, action) => {
            state.id = action.meta.arg;
            state.submitting = true;
        }).addCase(deleteCrossReference.fulfilled, (state) => {
            state.id = null;
            state.submitting = false;
            state.successOnDelete = 'Cross reference deleted successfully!';
        }).addCase(deleteCrossReference.rejected, (state, action) => {
            state.submitting = false;
            state.error = extractError(action);
        });
    },
});

export const {
    resetDeleteCrossReferenceStateOnError,
    resetDeleteCrossReferenceStateOnSuccess,
} = deleteCrossReferenceSlice.actions;

export default deleteCrossReferenceSlice.reducer;
